exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-crew-tsx": () => import("./../../../src/pages/crew.tsx" /* webpackChunkName: "component---src-pages-crew-tsx" */),
  "component---src-pages-destination-tsx": () => import("./../../../src/pages/destination.tsx" /* webpackChunkName: "component---src-pages-destination-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-technology-tsx": () => import("./../../../src/pages/technology.tsx" /* webpackChunkName: "component---src-pages-technology-tsx" */)
}

